import { render, staticRenderFns } from "./SliderType2.vue?vue&type=template&id=165a9564&scoped=true"
import script from "./SliderType2.vue?vue&type=script&lang=js"
export * from "./SliderType2.vue?vue&type=script&lang=js"
import style0 from "./SliderType2.vue?vue&type=style&index=0&id=165a9564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a9564",
  null
  
)

export default component.exports